import * as React from "react";
import { IconBase, IIconBase } from "src/icons/IconBase";

export const CargoIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Equipment for Cargo</title>
    <path d="M18 27H5v4l8 6h30v-8H18v-2zm9-8h4v2h-4zm6 0h4v2h-4zm6 0h4v2h-4zm-12 4h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-21 2V12h-4v9H5v4h13z" />
  </IconBase>
);
